module.exports = __webpack_public_path__ + "img/logo-white.a24d6892.png";